export const ApplicationConstant = {
    ApplicationID : 16,
    clientId : 10,
    organizationId: 60,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 15
}